// extracted by mini-css-extract-plugin
export default {"container":"whynps_container__MlXmf","cardContainer":"whynps_cardContainer__-JSNm"};